import React, { useContext } from 'react';
import { Button, Icon } from '@/components/shared';
import { SegmentationContext } from '@/contexts/SegmentationContext';
import { useGetTranslations } from '@/generated/translations';
import styles from './CorporateLink.module.scss';

export const CorporateLink: React.FC = () => {
	const { segmentationId } = useContext(SegmentationContext);
	const { data: translations } = useGetTranslations(segmentationId);

	return (
		<Button className={styles.corporateLink} variant={'linkButton'} href={'https://www.cjc.dk/'} target={'_blank'}>
			<span>{translations?.data.shared.navigation.corporateLink}</span>
			<Icon name={'arrowOut'} size={'md'} />
		</Button>
	);
};
